import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=15b889f2"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"
import style0 from "./Empresa.vue?vue&type=style&index=0&id=15b889f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports